import Selector from './Selector';

export default Selector;